import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';

// Components
import withLocalization from '~/hoc/withLocalization';
import applicationRouter from '~/hoc/applicationRouter';
import newlogo from '../../assets/img/new-logo.png';

class ResetPasswordPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
            confirmPassword: '',
            showPassword: false,
            showConfirmPassword: false,
            isSuccess: false,
        };
    }

    componentDidMount() {
        const params = new URLSearchParams(this.props.router.location.search);
        const lang = params.get('lang');
        if (lang) {
            this.props.commonStore.setAppLang(lang);
        }
    }

    getToken() {
        const params = new URLSearchParams(this.props.router.location.search);
        return params.get('token');
    }

    handleSubmitForm = async (e) => {
        e.preventDefault();
        const { password, confirmPassword } = this.state;
        const { t, authStore, commonStore } = this.props;

        if (password !== confirmPassword) {
            commonStore.addNotification(t('Passwords do not match'), null, 'error');
            return;
        }

        const token = this.getToken();
        if (!token) {
            commonStore.addNotification(t('Reset link is invalid or has expired'), null, 'error');
            return;
        }

        try {
            const result = await authStore.resetPasswordViaLink(token, password);
            if (result && result.success) {
                this.setState({ isSuccess: true });
            }
        } catch (err) {
            commonStore.addNotification(t('Reset link is invalid or has expired'), null, 'error');
        }
    };

    render() {
        const { t } = this.props;
        const { password, confirmPassword, showPassword, showConfirmPassword, isSuccess } = this.state;

        return (
            <div>
                <div className="auth-page-wrapper">
                    <ToastContainer />
                    <div className="auth-page-card">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h2 className="fs22 loginTitle">{t('Reset').toUpperCase()} {t('Password').toUpperCase()}</h2>
                            <img src={newlogo} alt="Logo" style={{ height: 42, cursor: 'pointer' }} onClick={() => this.props.router.navigate('/')} />
                        </div>
                        {isSuccess ? (
                            <>
                                <p className="forogottext mb-3">
                                    {t('Your password has been reset successfully')}.
                                </p>
                                <div className="d-flex w-100 justify-content-between mt-3 mb-3">
                                    <Link className="fs18 loginFooter border-none text-decoration-none" to="/login">
                                        {t('Back to login')}
                                    </Link>
                                </div>
                            </>
                        ) : (
                            <form className="login-container" onSubmit={this.handleSubmitForm}>
                                <div className="row">
                                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                        <div className="form-group business-name">
                                            <label htmlFor="newPassword" className="fw-bold">
                                                {t('New')} {t('Password')}
                                            </label>
                                            <label className="red-star">*</label>
                                            <div className="position-relative w-100">
                                                <input
                                                    id="newPassword"
                                                    type={showPassword ? 'text' : 'password'}
                                                    className="form-control login-input mt-12 mb_25"
                                                    placeholder={`${t('New')} ${t('Password')}`}
                                                    required
                                                    value={password}
                                                    onChange={(e) => this.setState({ password: e.target.value })}
                                                />
                                                <span
                                                    className="position-absolute color-gray cursor-pointer"
                                                    style={{ top: 12, right: 10 }}
                                                    onClick={() => this.setState({ showPassword: !showPassword })}
                                                >
                                                    {showPassword
                                                        ? <i className="fas fa-eye-slash" />
                                                        : <i className="fas fa-eye" />}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                        <div className="form-group business-name">
                                            <label htmlFor="confirmPassword" className="fw-bold">
                                                {t('Confirm')} {t('Password')}
                                            </label>
                                            <label className="red-star">*</label>
                                            <div className="position-relative w-100">
                                                <input
                                                    id="confirmPassword"
                                                    type={showConfirmPassword ? 'text' : 'password'}
                                                    className="form-control login-input mt-12 mb_25"
                                                    placeholder={`${t('Confirm')} ${t('Password')}`}
                                                    required
                                                    value={confirmPassword}
                                                    onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                                                />
                                                <span
                                                    className="position-absolute color-gray cursor-pointer"
                                                    style={{ top: 12, right: 10 }}
                                                    onClick={() => this.setState({ showConfirmPassword: !showConfirmPassword })}
                                                >
                                                    {showConfirmPassword
                                                        ? <i className="fas fa-eye-slash" />
                                                        : <i className="fas fa-eye" />}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button className="btn btn-block fwBold fs18 loginbutton" type="submit">
                                    {t('Reset')} {t('Password')}
                                </button>
                                <div className="d-flex w-100 justify-content-start mt-3 mb-3">
                                    <button
                                        type="button"
                                        className="fs18 loginFooter border-none"
                                        onClick={() => this.props.router.navigate('/login')}
                                    >
                                        {t('Back to login')}
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default inject('authStore', 'commonStore')(applicationRouter(withLocalization(observer(ResetPasswordPage))));
